import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InventoryService from '../../../../services/InventoryService';
import { ENUMS } from '../../../../utils/constants';

const ListLotItemGeneral = (props) => {
    const adjust = (id) => {
        let model = {};
        model.lotItemId = id;
        model.inventoryId = props.filter.inventoryId;
        props.adjust(model, () => {
            props.refresh();
        });
    }

    return (
        <>
            <span className="title sixth-text-color right" style={{ position: 'absolute', marginTop: '30px', right: '50px', zIndex: '999' }}>
                <i className="mdi mdi-check" onClick={() => adjust(props.itemProps.lotItemId)} />
            </span>
            <span className="title sixth-text-color right" style={{ position: 'absolute', marginTop: '30px', right: '20px', zIndex: '999' }}>
                {(props.itemProps.lotOriginId === ENUMS.eInventoryOriginCount.Drone.value ? <i className="mdi mdi-quadcopter" /> : <i className="mdi mdi-cellphone-android" />)}
            </span>
            <span className="title sixth-text-color">
                <i className="mdi mdi-text-box-check-outline" /> {`${props.itemProps.lotItemNumber}`}
            </span>
            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                <i className="mdi mdi-map-marker-radius-outline" /> {props.itemProps.location}
            </span>
            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                <i className="mdi mdi-image-filter-center-focus" /> {props.itemProps.cim}
            </span>
            {/* <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-image-filter-center-focus" /> {props.itemProps.lot.zoneCode}
                </span> */}
        </>
    )
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        filter: state.inventoryReducer.filter,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        adjust: (model, callback) => {
            dispatch(InventoryService.adjustLotItem(model, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListLotItemGeneral));
